import * as React from 'react';
import {  withStyles,  createStyles, WithStyles, Typography} from '@material-ui/core';


/// @Author : Simon @ AmbassadorsLAB
/// <Summary>
/// 
/// </Summary>

const styles = 
  createStyles({
    root: {
      display: 'flex',
      width: '100vw',
      height: '100vh',     
    },
    typography: {
      margin: 'auto',
    }
  });

interface IComponentProperties extends WithStyles<typeof styles> {
}

class HomePage extends React.Component<IComponentProperties> {
  public render() {
    const {classes} = this.props;

    document.title = "Nuclear Panda";

    return (
      <div className={classes.root}>
        <Typography className={classes.typography} variant={'h1'} > Nuclear Panda </Typography>
      </div>
    );
  }
}

export default withStyles(styles) (HomePage);



// WEBPACK FOOTER //
// ./src/Components/Layout/HomePage.tsx